import i18n from 'i18n-js';
import { DateHistoryData } from './index';
import { ChartDataItem, ChartDateFilter } from './components/Charts';
import { DateFilterType } from '../DateFIlters';

const faker = require('faker');

export function formatDateForCheck(date: string) {
    const jsDate = new Date(date);
    return `${jsDate.getDate()}.${jsDate.getMonth()}`;
}

export function getDayAgo(filterNumber: number) {
    let dayAgo = 1;
    const now = new Date();
    switch (filterNumber) {
        case 2:
            let dayNumber = now.getDay() - 1;
            dayNumber = dayNumber === -1 ? 6 : dayNumber;
            dayAgo = dayNumber;
            break;
        case 3:
            dayAgo = now.getDate() - 1;
            break;
        case 4:
            const start = new Date(now.getFullYear(), 0, 0);
            const diff =
                // @ts-ignore
                now - start + (start.getTimezoneOffset() - now.getTimezoneOffset()) * 60 * 1000;
            const oneDay = 1000 * 60 * 60 * 24;
            const day = Math.floor(diff / oneDay);
            dayAgo = day - 1;
    }

    return dayAgo;
}

export function getSelectedDateString(dayAgo: number) {
    const dateFrom = new Date();
    const dateTo = new Date();
    dateTo.setDate(dateFrom.getDate() - dayAgo);

    const dateToDay = dateTo.getDate();
    const dateToMonth = dateTo.getMonth();

    if (dayAgo !== 0) {
        const dateFromDay = dateFrom.getDate();
        const dateFromMonth = dateFrom.getMonth();

        return `${dateToDay} ${i18n.t(
            'common.monthNames.' + dateToMonth
        )} - ${dateFromDay} ${i18n.t('common.monthNames.' + dateFromMonth)} `;
    } else {
        return `${dateToDay} ${i18n.t('common.monthNames.' + dateToMonth)}`;
    }
}

export function getChartLabels(
    dateFilter: DateFilterType,
    secondaryDateFilter: ChartDateFilter,
    selectedDatesHistory: DateHistoryData[]
) {
    const labels: { name: string; date: Date; endDate?: undefined | Date }[] = [];

    const currentDate = new Date();
    let currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentMonthDay = currentDate.getDate();

    let lastDayOfMonth = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
    ).getDate();
    let isCustom: boolean | undefined = false;

    let lastHistoryDate, lastHistoryEndDate;
    const selectedDatesHistoryLength = selectedDatesHistory.length;
    if (selectedDatesHistory[selectedDatesHistoryLength - 1]) {
        isCustom = selectedDatesHistory[selectedDatesHistoryLength - 1].isCustom;
        lastHistoryDate = new Date(selectedDatesHistory[selectedDatesHistoryLength - 1].startDate);
        lastHistoryEndDate = new Date(selectedDatesHistory[selectedDatesHistoryLength - 1].endDate);
        currentYear = lastHistoryDate.getFullYear();

        lastDayOfMonth = new Date(
            currentDate.getFullYear(),
            lastHistoryDate.getMonth() + 1,
            0
        ).getDate();
    }

    if (dateFilter === DateFilterType.YEAR && secondaryDateFilter === ChartDateFilter.MONTHS) {
        const targetYear = lastHistoryDate ? lastHistoryDate.getFullYear() : currentYear;

        for (let i = 0; i < 12; i++) {
            const monthStartDate = new Date(targetYear, i, 1);
            const monthEndDate = new Date(targetYear, i + 1, 0); // Last day of the month

            labels.push({
                name: i18n.t(`common.monthNames.${i}`),
                date: monthStartDate,
                endDate: monthEndDate,
            });
        }
    } else if (
        (dateFilter === DateFilterType.CUSTOM || dateFilter === DateFilterType.CLOSING) &&
        secondaryDateFilter === ChartDateFilter.MONTHS
    ) {
        if (lastHistoryDate && lastHistoryEndDate) {
            const startDate = new Date(lastHistoryDate);
            let endDate = new Date(lastHistoryEndDate);

            // If endDate is at midnight (00:00:00), exclude that day
            if (
                endDate.getHours() === 0 &&
                endDate.getMinutes() === 0 &&
                endDate.getSeconds() === 0
            ) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate() - 1); // Move back to previous day
                endDate.setHours(23, 59, 59, 999); // Set to end of that day
            }

            // Start from the first day of the start month
            let currentMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
            const endMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

            while (currentMonth <= endMonth) {
                const monthStartDate = new Date(
                    currentMonth.getFullYear(),
                    currentMonth.getMonth(),
                    1
                );
                const monthEndDate = new Date(
                    currentMonth.getFullYear(),
                    currentMonth.getMonth() + 1,
                    0
                ); // Last day of the month

                // For the first month, adjust start date to the actual start date
                if (
                    currentMonth.getTime() ===
                    new Date(startDate.getFullYear(), startDate.getMonth(), 1).getTime()
                ) {
                    monthStartDate.setDate(startDate.getDate());
                    monthStartDate.setHours(
                        startDate.getHours(),
                        startDate.getMinutes(),
                        startDate.getSeconds(),
                        startDate.getMilliseconds()
                    );
                }

                // For the last month, adjust end date to the actual end date
                if (currentMonth.getTime() === endMonth.getTime()) {
                    monthEndDate.setDate(endDate.getDate());
                    monthEndDate.setHours(
                        endDate.getHours(),
                        endDate.getMinutes(),
                        endDate.getSeconds(),
                        endDate.getMilliseconds()
                    );
                }

                labels.push({
                    name: i18n.t(`common.monthNames.${currentMonth.getMonth()}`),
                    date: new Date(monthStartDate),
                    endDate: new Date(monthEndDate),
                });

                // Move to next month
                currentMonth.setMonth(currentMonth.getMonth() + 1);
            }
        }
    } else {
        switch (secondaryDateFilter) {
            case ChartDateFilter.HOURS:
                if (
                    lastHistoryDate &&
                    lastHistoryEndDate &&
                    lastHistoryDate.getTime() !== lastHistoryEndDate.getTime()
                ) {
                    // Calculate hours based on the actual date range
                    let startDate = new Date(lastHistoryDate);
                    let endDate = new Date(lastHistoryEndDate);
                    if (dateFilter === DateFilterType.DAY) {
                        startDate = new Date(lastHistoryDate);
                        startDate.setHours(0, 0, 0, 0);
                        endDate = new Date(startDate);
                        endDate.setHours(23, 59, 59, 999);
                    }
                    let currentHour = new Date(startDate);
                    currentHour.setMinutes(0, 0, 0); // Reset to start of hour

                    const endHour = new Date(endDate);
                    endHour.setMinutes(59, 59, 999); // End of the hour
                    while (currentHour <= endHour) {
                        const hour = currentHour.getHours();
                        const day = currentHour.getDate();
                        const month = currentHour.getMonth();
                        const year = currentHour.getFullYear();

                        // Format label to show hour and optionally date if spanning multiple days
                        let labelName = `${hour}h`;
                        if (startDate.getDate() !== endDate.getDate()) {
                            // If spanning multiple days, include date in label
                            labelName = `${day}.${month + 1} ${hour}h`;
                        }

                        labels.push({
                            name: labelName,
                            date: new Date(year, month, day, hour),
                        });

                        // Move to next hour
                        currentHour.setHours(currentHour.getHours() + 1);
                    }
                } else {
                    // Fallback to current day 24 hours if no history data
                    for (let i = 0; i <= 23; i++) {
                        labels.push({
                            name: `${i}h`,
                            date: new Date(currentYear, currentMonth, currentMonthDay, i),
                        });
                    }
                }
                break;
            case ChartDateFilter.DAYS:
                if (
                    lastHistoryDate &&
                    lastHistoryEndDate &&
                    lastHistoryDate.getTime() !== lastHistoryEndDate.getTime()
                ) {
                    // Handle custom date range for days
                    const startDate = new Date(lastHistoryDate);
                    let endDate = new Date(lastHistoryEndDate);

                    // If endDate is at midnight (00:00:00), exclude that day
                    if (
                        endDate.getHours() === 0 &&
                        endDate.getMinutes() === 0 &&
                        endDate.getSeconds() === 0
                    ) {
                        endDate = new Date(endDate);
                        endDate.setDate(endDate.getDate() - 1); // Move back to previous day
                        endDate.setHours(23, 59, 59, 999); // Set to end of that day
                    }

                    // Check if the range spans multiple months
                    const spansMultipleMonths =
                        startDate.getMonth() !== endDate.getMonth() ||
                        startDate.getFullYear() !== endDate.getFullYear();

                    let currentDate = new Date(startDate);
                    currentDate.setHours(0, 0, 0, 0);

                    while (currentDate <= endDate) {
                        const day = currentDate.getDate();
                        const month = currentDate.getMonth();
                        const year = currentDate.getFullYear();
                        const dayOfWeek = currentDate.getDay();

                        // Format the day name
                        let dayName;
                        if (spansMultipleMonths) {
                            // Include month when spanning multiple months
                            const monthName = i18n.t(`common.monthNames.${month}`);
                            const weekDayName = i18n
                                .t(`common.weekDays.${dayOfWeek.toString()}`)
                                .substr(0, 3);
                            dayName = `${day} ${monthName} ${weekDayName}`;
                        } else {
                            // Just day and weekday for single month
                            const weekDayName = i18n
                                .t(`common.weekDays.${dayOfWeek.toString()}`)
                                .substr(0, 3);
                            dayName = `${day} ${weekDayName}`;
                        }

                        const dayStart = new Date(year, month, day, 0, 0, 0, 0);
                        const dayEnd = new Date(year, month, day, 23, 59, 59, 999);

                        labels.push({
                            name: dayName,
                            date: dayStart,
                            endDate: dayEnd,
                        });

                        // Move to next day
                        currentDate.setDate(currentDate.getDate() + 1);
                    }
                } else {
                    // Default behavior for single week
                    const d = new Date(currentDate);
                    const day = d.getDay(),
                        diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday
                    let startingDay = lastHistoryDate
                        ? lastHistoryDate.getDate()
                        : new Date(d.setDate(diff)).getDate();
                    const week = Math.ceil((lastHistoryDate?.getDate() || startingDay) / 7);
                    if (week >= 5 || lastHistoryDate?.getDay() === 0) {
                        startingDay += getExtraDaysUntil(lastHistoryDate?.getDay() || 0, 1);
                    }

                    let count = 0;
                    for (let i = 0; i <= 6; i++) {
                        let endDay = startingDay + i + 7;
                        endDay = endDay > 31 ? 31 : endDay;

                        let lastStartingDay = startingDay + i;
                        let extraMonth = 0;
                        if (lastStartingDay > lastDayOfMonth) {
                            lastStartingDay = lastStartingDay - lastDayOfMonth;
                            extraMonth = 1;
                        }

                        const endDate = new Date(
                            lastHistoryDate ? lastHistoryDate.getFullYear() : currentYear,
                            lastHistoryDate ? lastHistoryDate.getMonth() : currentMonth,
                            endDay
                        );

                        const date = new Date(
                            currentYear,
                            lastHistoryDate
                                ? lastHistoryDate.getMonth() + extraMonth
                                : currentMonth,
                            lastStartingDay
                        );
                        if (endDate.getDay() === 1 && week === 1 && count > 0) {
                            break;
                        }
                        labels.push({
                            name:
                                lastStartingDay +
                                ' ' +
                                i18n.t(`common.weekDays.${date.getDay().toString()}`).substr(0, 3),
                            date,
                            endDate,
                        });

                        if (date.getDate() >= lastDayOfMonth) {
                            break;
                        }
                        count += 1;
                    }
                }

                break;
            case ChartDateFilter.WEEKS:
                if (
                    lastHistoryDate &&
                    lastHistoryEndDate &&
                    lastHistoryDate.getTime() !== lastHistoryEndDate.getTime()
                ) {
                    // Handle custom date range for weeks
                    const startDate = new Date(lastHistoryDate);
                    let endDate = new Date(lastHistoryEndDate);

                    // If endDate is at midnight (00:00:00), exclude that day
                    if (
                        endDate.getHours() === 0 &&
                        endDate.getMinutes() === 0 &&
                        endDate.getSeconds() === 0
                    ) {
                        endDate = new Date(endDate);
                        endDate.setDate(endDate.getDate() - 1); // Move back to previous day
                        endDate.setHours(23, 59, 59, 999); // Set to end of that day
                    }

                    // Check if the range spans multiple months
                    const spansMultipleMonths =
                        startDate.getMonth() !== endDate.getMonth() ||
                        startDate.getFullYear() !== endDate.getFullYear();

                    // Find the Monday of the week containing startDate
                    let currentWeekStart = new Date(startDate);
                    const dayOfWeek = currentWeekStart.getDay();
                    const daysToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Adjust for Monday start
                    currentWeekStart.setDate(currentWeekStart.getDate() - daysToMonday);
                    currentWeekStart.setHours(0, 0, 0, 0);

                    // Track weeks by actual calendar weeks, not by month
                    let weekCounter = 1;
                    let lastWeekPrimaryMonth = -1;
                    let weekInCurrentMonth = 0;

                    while (currentWeekStart <= endDate) {
                        const weekEnd = new Date(currentWeekStart);
                        weekEnd.setDate(weekEnd.getDate() + 6); // Sunday of the same week
                        weekEnd.setHours(23, 59, 59, 999);

                        // Determine which month this week primarily belongs to
                        // Use the middle of the week (Wednesday) to determine the month
                        const weekMiddle = new Date(currentWeekStart);
                        weekMiddle.setDate(weekMiddle.getDate() + 3); // Wednesday
                        const weekPrimaryMonth = weekMiddle.getMonth();

                        // Check if we've moved to a new month
                        if (weekPrimaryMonth !== lastWeekPrimaryMonth) {
                            lastWeekPrimaryMonth = weekPrimaryMonth;
                            weekInCurrentMonth = 1; // Reset week counter for new month
                        } else {
                            weekInCurrentMonth++; // Increment week counter for same month
                        }

                        // Format the week name
                        let weekName;
                        if (spansMultipleMonths) {
                            // Include month name when spanning multiple months
                            const monthName = i18n.t(`common.monthNames.${weekPrimaryMonth}`);
                            weekName = `${monthName} ${weekInCurrentMonth} ${i18n.t(
                                'common.week'
                            )}`;
                        } else {
                            // For single month or when we want simple numbering, use sequential week numbers
                            weekName = `${weekCounter} ${i18n.t('common.week')}`;
                        }

                        labels.push({
                            name: weekName,
                            date: new Date(currentWeekStart),
                            endDate: new Date(weekEnd),
                        });

                        // Move to next week
                        currentWeekStart.setDate(currentWeekStart.getDate() + 7);
                        weekCounter++; // Always increment the sequential counter
                    }
                } else {
                    // Default behavior for single month
                    const date = lastHistoryDate ? lastHistoryDate : new Date();
                    let startDay = 1,
                        endDay = getDaysUntilMonday(date);
                    for (let i = 1; i <= getWeeksAmountOfMonth(date); i++) {
                        if (i > 1) {
                            startDay = endDay;
                            endDay += 7;
                            endDay = endDay > lastDayOfMonth ? lastDayOfMonth : endDay;
                        }
                        labels.push({
                            name: `${i} ${i18n.t('common.week')}`,
                            date: new Date(
                                lastHistoryDate ? lastHistoryDate.getFullYear() : currentYear,
                                lastHistoryDate ? lastHistoryDate.getMonth() : currentMonth,
                                startDay
                            ),
                            endDate: new Date(
                                lastHistoryDate ? lastHistoryDate.getFullYear() : currentYear,
                                lastHistoryDate ? lastHistoryDate.getMonth() : currentMonth,
                                endDay
                            ),
                        });
                    }
                }
                break;
        }
    }
    return labels;
}

export function getChartDataSet(
    selectedServices: boolean[],
    legend: {id: string, name: string}[],
    labels: { name: string; date: Date; endDate?: Date }[],
    dataList: ChartDataItem[],
    selectedFilter: DateFilterType,
    selectedSecondaryFilter: ChartDateFilter,
    showFakeData: boolean
) {
    const dataSet: { label: string; backgroundColor: string; data: number[]; minBarLength: number }[] =
        [];
    const COLORS = ['#92C2EE', '#FFA899', '#C1C0ED', '#818181', '#A3D39C', '#FFD700'];
    function filterDataByDate(date: string, dateOfLabel: Date) {
        const eachDate = normalizeServerDate(date)
        if (
            (selectedFilter === DateFilterType.YEAR || selectedFilter === DateFilterType.CUSTOM) &&
            selectedSecondaryFilter === ChartDateFilter.MONTHS
        ) {
            return (
                dateOfLabel.getFullYear() === eachDate.getFullYear() &&
                dateOfLabel.getMonth() === eachDate.getMonth()
            );
        } else {
            switch (selectedSecondaryFilter) {
                case ChartDateFilter.HOURS: {
                    return (
                        dateOfLabel.getHours() === eachDate.getHours() &&
                        dateOfLabel.getDate() === eachDate.getDate()
                    );
                }
                case ChartDateFilter.DAYS: {
                    return (
                        dateOfLabel.getDay() === eachDate.getDay() &&
                        dateOfLabel.getDate() === eachDate.getDate()
                    );
                }
                case ChartDateFilter.WEEKS: {
                    // Check if both dates are from the same week
                    const startWeekOfMonth = getWeekOfMonth(dateOfLabel);
                    const eachWeekOfMonth = getWeekOfMonth(eachDate);

                    return (
                        startWeekOfMonth === eachWeekOfMonth &&
                        dateOfLabel.getMonth() === eachDate.getMonth() &&
                        dateOfLabel.getFullYear() === eachDate.getFullYear()
                    );
                }
                case ChartDateFilter.MONTHS: {
                    return dateOfLabel.getMonth() === eachDate.getMonth();
                }
            }
        }
    }

    selectedServices.forEach((isSelected, i) => {
        const { id, name } = legend[i] ?? { id: null, name: null };
        if (id === null) return;

        if (isSelected) {
            const dataSetData: number[] = [];
            labels.forEach((item) => {
                const dateOfLabel = item.date;
                const filteredFinanceOrders = dataList
                    .filter((each) => each.name === id)
                    .filter((financeItem) =>
                        filterDataByDate(financeItem.date, dateOfLabel)
                    );

                let totalAmount = 0;
                filteredFinanceOrders.forEach((each) => {
                    totalAmount += each.amount;
                });

                dataSetData.push(totalAmount);
            });

            dataSet.push({
                label: name,
                backgroundColor: COLORS[i % COLORS.length],
                data: !showFakeData
                    ? dataSetData
                    : labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
                minBarLength: 15,
            });
        } else {
            dataSet.push({
                label: name,
                backgroundColor: COLORS[i % COLORS.length],
                data: !showFakeData
                    ? []
                    : labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
                minBarLength: 15,
            });
        }
    });

    return dataSet;
}

export function isChartStacked(dateFilter: number, secondaryDateFilter: number) {
    switch (dateFilter) {
        case 3: {
            return secondaryDateFilter !== 0;
        }
        case 4:
            return false;
        default:
            return true;
    }
}

export function createDateHistoryList(until: number, date: Date, weekCount: number = 1) {
    const dateHistoryList = [];

    const year = date.getFullYear();
    const month = date.getMonth();
    const monthDay = date.getDate();

    let startDate, endDate;

    for (let i = 1; i <= until; i++) {
        let name = '';
        switch (i) {
            case 1:
                name = `${year}`;
                startDate = new Date(year, 0, 1);
                endDate = new Date(year + 1, 0, 1);
                break;
            case 2:
                name = `${i18n.t('common.monthNames.' + month)}`;
                startDate = new Date(year, month);
                endDate = new Date(year, month + 1);
                break;
            case 3:
                name = `${weekCount} ${i18n.t('common.week')}`;
                startDate = new Date(year, month, monthDay);
                endDate = new Date(year, month, monthDay + 7);
                break;
            case 4:
                name = `${monthDay} ${i18n.t('common.monthNames.' + month)} ${year}`;
                startDate = new Date(year, month, monthDay);
                endDate = new Date(year, month, monthDay + 1);
        }

        dateHistoryList.push({
            name,
            startDate,
            endDate,
        });
    }

    return dateHistoryList;
}

function getDaysUntilMonday(date: Date): number {
    let dayNumber = date.getDay();
    dayNumber = dayNumber === 0 ? 7 : dayNumber;
    return 8 - dayNumber;
}

function getWeeksAmountOfMonth(date: Date) {
    const firstDay = new Date(date.setDate(1)).getDay() - 1;
    const totalDays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    return Math.ceil((firstDay + totalDays) / 7);
}

/* function getNextMonday(d: Date) {
    d.setDate(d.getDate() + ((((7 - d.getDay()) % 7) + 1) % 7));
    return d;
} */

function normalizeServerDate(serverDate: string) {
    const parts = serverDate.split('-');
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1;
    const day = parseInt(parts[2].substr(0, 2));
    const hourParts = serverDate.split(':');
    const hours = parseInt(hourParts[0].substr(-2));
    const minutes = parseInt(hourParts[1]);
    return new Date(year, month, day, hours, minutes);
}

function getWeekOfMonth(date: Date): number {
    const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfWeek = firstDayOfMonth.getDay();

    // Adjust for Monday as first day of week (0 = Monday, 6 = Sunday)
    const adjustedFirstDay = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

    // Calculate which week this date falls into
    const dayOfMonth = date.getDate();
    const weekNumber = Math.ceil((dayOfMonth + adjustedFirstDay) / 7);

    return weekNumber;
}

export function getExtraDaysUntil(currentDayNumber: number, untilDayNumber: number) {
    let extraDays = 0;
    for (let i = 0; i < 8; i++) {
        if (currentDayNumber === 6) {
            currentDayNumber = 0;
        } else {
            currentDayNumber++;
        }
        extraDays++;

        if (untilDayNumber === currentDayNumber) {
            break;
        }
    }
    return extraDays;
}
